import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle'
import { useTranslation } from 'react-i18next'
import { Input } from 'antd'
import { slices } from 'store/slices'
import { useAppDispatch } from 'store/hooks'
import { IQuestionBankSection } from 'interfaces/questionBank'
import { Title, Counter } from './styled'

interface IProps {
  section: IQuestionBankSection
}

const Description = ({ section }: IProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const translationPrefix = 'administration.blocks.type.questionBankV2.sections'

  return (
    <>
      <Title style={{ marginTop: 4 }}>
        {t(`${translationPrefix}.description.title`)}
        <FontAwesomeIcon icon={faInfoCircle} />
      </Title>
      <Input
        value={section.description || ''}
        maxLength={200}
        onChange={(e) =>
          dispatch(
            slices.questionBank.setSectionDescription({
              sectionOrder: section.order,
              description: e.target.value,
            })
          )
        }
        placeholder={t(`${translationPrefix}.description.placeholder`)}
      />
      <Counter>
        <FontAwesomeIcon icon={faInfoCircle} />
        {section.description?.length || 0}/200{' '}
        {t(`${translationPrefix}.description.counter`)}
      </Counter>
    </>
  )
}

export default Description
